import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Button, IconButton, Typography, useMediaQuery, } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "@application/store/useStore";
import { useEffect } from "react";
import WNSwitch from "@ui/components/wn-switch";
import { DataGrid } from "@mui/x-data-grid";
import { AppConsts } from "@application/common/constants/app-consts";
import WnNoRecordFound from "@ui/components/wn-no-record";
import { enableDisableRoleAsync, getRolesAsync, } from "@application/features/role/roleThunk";
import { RoleEnum } from "@application/common/enums/role";
import { FilterAltOff } from "@mui/icons-material";
import "./style.scss";
import { validateModulePermission } from "@application/common/helpers/role-claims-helper";
import { Module } from "@application/common/enums/modules";
import { PermissionType } from "@application/common/enums/permission-type";
import { translate } from "@application/common/helpers/translate";
import { resetFilter } from "@application/features/common/filterResetSlice";
import { setRoleFilterModel } from "@application/features/role/roleSlice";
const RolePermissions = () => {
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const { roles, roleFilterModel } = useAppSelector((state) => state.role);
    const { currentUser } = useAppSelector((state) => state.auth);
    const { loggedInUserRolePermission } = useAppSelector((state) => state.rolePermission);
    const modulePermissions = loggedInUserRolePermission &&
        validateModulePermission(loggedInUserRolePermission, Module[Module["Role Permissions"]]);
    const hasViewPermission = modulePermissions
        ? !!modulePermissions[PermissionType[PermissionType.viewPermission]]
        : false;
    const hasCreatePermission = modulePermissions
        ? !!modulePermissions[PermissionType[PermissionType.createPermission]]
        : false;
    const hasEditPermission = modulePermissions
        ? !!modulePermissions[PermissionType[PermissionType.editPermission]]
        : false;
    useEffect(() => {
        dispatch(getRolesAsync());
    }, [dispatch]);
    useEffect(() => {
        dispatch(resetFilter("permissions"));
    }, [dispatch]);
    const onEnableDisable = ($event, id, name) => {
        // if (includeRoles.includes(name)) {
        //   return;
        // }
        dispatch(enableDisableRoleAsync({ id: id, status: $event })).then((res) => {
            if (res.payload === true) {
                dispatch(getRolesAsync());
            }
        });
    };
    const onDetailsClick = (role) => {
        navigate(`${role.id}`);
    };
    const includeRoles = [
        "SuperAdmin",
        "Admin",
        "Board",
        "School",
        "Teacher",
        "Supervisor",
        "Student",
    ];
    const isSmall = useMediaQuery("(min-width:100px) and (max-width:1200px)");
    const columns = [
        {
            field: "roleDisplayName",
            headerName: translate("permissions.roleName").toUpperCase(),
            sortable: true,
            flex: 1,
            minWidth: isSmall ? 180 : undefined,
            hideable: false,
        },
        {
            field: "usersCount",
            headerName: translate("permissions.users").toUpperCase(),
            sortable: true,
            flex: 1,
            minWidth: isSmall ? 180 : undefined,
            hideable: false,
        },
        {
            field: "isActive",
            headerName: translate("common.active").toUpperCase(),
            sortable: false,
            flex: 1,
            minWidth: isSmall ? 180 : undefined,
            align: "center",
            headerAlign: "center",
            hideable: false,
            filterable: false,
            hideSortIcons: true,
            cellClassName: "tableSwitchAlignCenter",
            renderCell: (params) => (_jsx(WNSwitch, { checked: params.row.isActive, 
                //disable={includeRoles.includes(params.row.name)}
                disable: params.row.name == RoleEnum[RoleEnum.SuperAdmin], onChange: ($event) => onEnableDisable($event, params.row.id, params.row.name) }, params.row.id)),
        },
        {
            field: "",
            headerName: translate("permissions.permissions").toUpperCase(),
            sortable: false,
            flex: 1,
            minWidth: isSmall ? 180 : undefined,
            align: "center",
            headerAlign: "center",
            hideable: false,
            filterable: false,
            hideSortIcons: true,
            renderCell: (params) => params.row.name == RoleEnum[RoleEnum.SuperAdmin] ? (_jsx(_Fragment, { children: " " })) : (_jsx(Button, { size: "small", className: "Button", disabled: !params.row.isActive, sx: { fontSize: "14px" }, onClick: () => onDetailsClick(params.row), children: translate("cta.details") })),
        },
    ];
    const onFilterModelChange = (model) => dispatch(setRoleFilterModel(model));
    const onClearFilterModel = () => dispatch(setRoleFilterModel({ items: [] }));
    const isxs = useMediaQuery("(min-width:100px) and (max-width:750px)");
    return (_jsxs(_Fragment, { children: [_jsxs(Box, { sx: { display: "flex" }, justifyContent: "space-between", alignItems: "center", children: [_jsx(Typography, { variant: "h5", sx: { fontWeight: "bold" }, children: translate("permissions.permissions") }), _jsx(Box, { sx: { display: "flex", alignItems: "center", gap: 1 }, children: isxs ? (_jsx(IconButton, { size: "medium", onClick: onClearFilterModel, children: _jsx(FilterAltOff, { fontSize: "medium" }) })) : (_jsx(Button, { className: "Button", variant: "outlined", disableElevation: true, color: "primary", onClick: onClearFilterModel, startIcon: _jsx(FilterAltOff, {}), children: "Clear Filter" })) })] }), _jsx(Box, { sx: {
                    marginTop: "1rem",
                    borderRadius: "12px",
                    backgroundColor: "#fff",
                    padding: "1rem",
                }, children: _jsx("div", { style: { width: "100%" }, children: _jsx(DataGrid, { componentsProps: { filterPanel: { sx: { maxWidth: "85vw" } } }, autoHeight: true, rows: roles?.filter((role) => {
                            // Exclude SuperAdmin role for non-super admin users
                            if (currentUser?.role != RoleEnum[RoleEnum.SuperAdmin] &&
                                role.name == RoleEnum[RoleEnum.SuperAdmin])
                                return false;
                            // Exclude Student role
                            if (role.name == RoleEnum[RoleEnum.Student])
                                return false;
                            return true;
                        }) ?? [], columns: columns, filterModel: roleFilterModel, onFilterModelChange: onFilterModelChange, initialState: {
                            pagination: {
                                paginationModel: {
                                    pageSize: AppConsts.GRID_DEFAULT_PAGE_SIZE,
                                },
                            },
                        }, pageSizeOptions: [AppConsts.GRID_DEFAULT_PAGE_SIZE], disableRowSelectionOnClick: true, hideFooterPagination: !roles?.length, slots: { noRowsOverlay: WnNoRecordFound }, sx: { "--DataGrid-overlayHeight": "300px" }, columnVisibilityModel: {
                            isActive: hasEditPermission ?? true,
                            "": (hasViewPermission || hasEditPermission) ?? true,
                        } }, "role-grid") }) })] }));
};
export default RolePermissions;
